import { render, staticRenderFns } from "./DoorDrop.vue?vue&type=template&id=e0642fb2&"
import script from "./DoorDrop.vue?vue&type=script&lang=js&"
export * from "./DoorDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports